import apiClient from './client';

export enum ApplicationStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export interface Application {
  _id: string;
  event: any;
  user: any;
  status: ApplicationStatus;
  message?: string;
  customFields?: Record<string, any>;
  reviewedBy?: any;
  reviewedAt?: string;
  reviewComment?: string;
  createdAt: string;
}

export interface CreateApplicationDto {
  eventId: string;
  message?: string;
  customFields?: Record<string, any>;
}

export interface ReviewApplicationDto {
  status: ApplicationStatus;
  comment?: string;
}

export const applicationsApi = {
  create: async (data: CreateApplicationDto): Promise<Application> => {
    const response = await apiClient.post('/applications', data);
    return response.data;
  },

  getAll: async (eventId?: string, status?: ApplicationStatus): Promise<Application[]> => {
    const params = new URLSearchParams();
    if (eventId) params.append('eventId', eventId);
    if (status) params.append('status', status);
    
    const response = await apiClient.get(`/applications?${params.toString()}`);
    return response.data;
  },

  getMy: async (): Promise<Application[]> => {
    const response = await apiClient.get('/applications/my');
    return response.data;
  },

  getById: async (id: string): Promise<Application> => {
    const response = await apiClient.get(`/applications/${id}`);
    return response.data;
  },

  review: async (id: string, data: ReviewApplicationDto): Promise<Application> => {
    const response = await apiClient.put(`/applications/${id}/review`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/applications/${id}`);
  },

  getStatistics: async (eventId: string) => {
    const response = await apiClient.get(`/applications/event/${eventId}/statistics`);
    return response.data;
  },

  exportParticipants: async (eventId: string, status?: ApplicationStatus) => {
    const params = status ? `?status=${status}` : '';
    window.open(
      `${apiClient.defaults.baseURL}/applications/event/${eventId}/export${params}`,
      '_blank'
    );
  },
};
